import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragmentDoc } from './order-guide-restaurant-collection-fields.generated';
const defaultOptions = {} as const;

export const CreateSalesPortalOrderGuideCollectionDocument = gql`
  mutation createSalesPortalOrderGuideCollection(
    $name: String!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    createOrderGuideCollection(
      name: $name
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_guide_collection_id
      order_guide_restaurant_collection {
        ...SalesPortalOrderGuides_OrderGuideRestaurantCollectionFields
      }
    }
  }
  ${SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragmentDoc}
`;
export type CreateSalesPortalOrderGuideCollectionMutationFn =
  Apollo.MutationFunction<
    Types.CreateSalesPortalOrderGuideCollectionMutation,
    Types.CreateSalesPortalOrderGuideCollectionMutationVariables
  >;
export function useCreateSalesPortalOrderGuideCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateSalesPortalOrderGuideCollectionMutation,
    Types.CreateSalesPortalOrderGuideCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateSalesPortalOrderGuideCollectionMutation,
    Types.CreateSalesPortalOrderGuideCollectionMutationVariables
  >(CreateSalesPortalOrderGuideCollectionDocument, options);
}
export type CreateSalesPortalOrderGuideCollectionMutationHookResult =
  ReturnType<typeof useCreateSalesPortalOrderGuideCollectionMutation>;
export type CreateSalesPortalOrderGuideCollectionMutationResult =
  Apollo.MutationResult<Types.CreateSalesPortalOrderGuideCollectionMutation>;
export type CreateSalesPortalOrderGuideCollectionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateSalesPortalOrderGuideCollectionMutation,
    Types.CreateSalesPortalOrderGuideCollectionMutationVariables
  >;
